<template>
  <KeyRoad />
</template>
<script>
import KeyRoad from '../components/index.vue'

export default {
  name: 'high-speed-road',
  components: {
    KeyRoad,
  },
  provide: {
    pRoadType: 'HIGHWAY',
  },
}
</script>
